module.exports = __webpack_public_path__ + "static/media/3.21.7ef9e16e.png";